import { Permission } from '../constants/permissions.js';
/** Read-only source-grounded guidance. */
export const dataSubjectsTour = {
    module: 'data_subjects',
    title: 'Data Subjects Tour',
    title_vi: 'Hướng dẫn Chủ thể dữ liệu',
    description: 'Find existing people, interpret linked activity and locate profile creation without changing records.',
    description_vi: 'Tìm người đã có hồ sơ, đọc hoạt động liên kết và xác định nơi tạo hồ sơ mà không thay đổi bản ghi.',
    estimated_duration_seconds: 90,
    revision: '2026-10-26.8',
    steps: [
        {
            step_id: 'explore_data_subjects',
            navigate_to: '/admin/data-subjects',
            target: '[data-testid="data-subject-list-page"] .dm-filters',
            wait_for: '[data-testid="data-subject-list-page"][data-tour-ready="true"] .dm-filters',
            title: 'Profiles',
            title_vi: 'Hồ sơ chủ thể dữ liệu',
            description: 'Search existing profiles before creating a person. The register joins case, CMP consent and consent-workflow activity for the selected identity; counts are links, not proof that all personal data has been found. A successful no-match is different from an unavailable read. This tour creates no profile or identifier.',
            description_vi: 'Tìm hồ sơ hiện có trước khi tạo người mới. Danh sách liên kết hoạt động hồ sơ yêu cầu, đồng ý từ CMP và quy trình đồng ý theo danh tính đã chọn; số lượng là liên kết, không chứng minh đã tìm thấy mọi dữ liệu cá nhân. Không có kết quả sau lần đọc thành công khác lần đọc không khả dụng. Hướng dẫn không tạo hồ sơ hoặc mã định danh.',
            position: 'bottom',
            duration_ms: 24000,
        },
        {
            step_id: 'subjects_search',
            navigate_to: '/admin/data-subjects',
            target: '[data-testid="data-subject-list-page"] input[type="search"]',
            title: 'Find an existing person',
            title_vi: 'Tìm người đã có hồ sơ',
            description: 'Search by name, email, phone or identifier before creating a profile. Reusing the existing profile helps keep work for the same person together.',
            description_vi: 'Tìm theo tên, email, điện thoại hoặc mã định danh trước khi tạo hồ sơ. Dùng hồ sơ hiện có giúp tập hợp công việc của cùng một người.',
            wait_for: '[data-testid="data-subject-list-page"][data-tour-ready="true"] input[type="search"]',
            position: 'bottom',
            duration_ms: 22000,
        },
        {
            step_id: 'subjects_activity',
            navigate_to: '/admin/data-subjects',
            target: '[data-testid="data-subject-list-page"] :is(.dm-table-wrap, .empty-state)',
            title: 'Read linked activity and open details',
            title_vi: 'Xem hoạt động liên kết và mở chi tiết',
            description: 'Compare case, CMP consent and consent-workflow counts with last activity, then choose the person’s name to open the profile. An empty result means no profile matches this search; it does not prove the person has no data elsewhere.',
            description_vi: 'Đối chiếu số hồ sơ yêu cầu, sự đồng ý từ CMP, quy trình đồng ý và hoạt động gần nhất; chọn tên người để mở hồ sơ. Kết quả trống chỉ có nghĩa là không có hồ sơ phù hợp, không chứng minh người đó không có dữ liệu ở nơi khác.',
            wait_for: '[data-testid="data-subject-list-page"][data-tour-ready="true"] :is(.dm-table-wrap, .empty-state)',
            position: 'bottom',
            duration_ms: 22000,
        },
        {
            step_id: 'subjects_create_entry',
            navigate_to: '/admin/data-subjects',
            target: '[data-testid="create-data-subject"]',
            title: 'Create after checking for duplicates',
            title_vi: 'Kiểm tra trùng lặp trước khi tạo',
            description: 'Create Profile opens a form for the display name and identifying contact information. Check existing identifiers before saving a new person. This tour only highlights the entry point; it opens or submits no form.',
            description_vi: 'Tạo hồ sơ mở biểu mẫu nhập tên hiển thị và thông tin liên hệ để nhận diện người đó. Kiểm tra thông tin định danh hiện có trước khi lưu người mới. Hướng dẫn chỉ giới thiệu nút này, không mở hoặc gửi biểu mẫu.',
            wait_for: '[data-testid="data-subject-list-page"][data-tour-ready="true"] [data-testid="create-data-subject"]',
            position: 'bottom',
            duration_ms: 22000,
            required_permissions: [Permission.DATA_SUBJECT_CREATE],
        },
    ],
};
//# sourceMappingURL=data-subjects.js.map